import { HebeModel, Vertical } from '@sbt-web/adv';
import { ADSENSE_STYLES } from '@/client/components/Adv/AdSense';
import { getAdSenseConfig } from '@/client/components/Adv/Lira/fallbackConfig/listing/adsenseConfig';
import { LiraContainerIds } from '@/client/components/Adv/Lira/liraContainerIds';

/**
 * The names for the skyscraper ad slots.
 */
const skyscrapernames: Array<{
  name: string;
  params: Record<string, string | number>;
}> = [
  {
    name: 'onetag',
    params: {
      pubId: '75b3d7d3be898e0',
    },
  },
  {
    name: 'criteo',
    params: {
      networkId: 280,
    },
  },
  {
    name: 'rubicon',
    params: {
      accountId: 23660,
      siteId: 381482,
      zoneId: 2114030,
    },
  },
  {
    name: 'pubmatic',
    params: {
      publisherId: '81997',
      adSlot: 'Subito_160x600-hb@160x600',
    },
  },
  {
    name: 'pubmatic',
    params: {
      publisherId: '81997',
      adSlot: 'Subito_300x600-hb@300x600',
    },
  },
  {
    name: 'pubmatic',
    params: {
      publisherId: '81997',
      adSlot: 'Subito_120x600-hb@120x600',
    },
  },
  {
    name: 'teads',
    params: {
      pageId: 149522,
      placementId: 163688,
    },
  },
  {
    name: 'appnexus',
    params: {
      placementId: 19698611,
    },
  },
  {
    name: 'openx',
    params: {
      delDomain: 'adevintaitaly-d.openx.net',
      unit: 541156882,
    },
  },
  {
    name: 'openx',
    params: {
      delDomain: 'adevintaitaly-d.openx.net',
      unit: 541156881,
    },
  },
  {
    name: 'appnexus',
    params: {
      placementId: 19698617,
    },
  },
  {
    name: 'ix',
    params: {
      siteId: 1131817,
    },
  },
];

export const getDesktopFallbackConfig = (vertical: Vertical): HebeModel => {
  const desktopFallbackConfig: HebeModel = {
    name: 'listing',
    page_level_settings: {
      adsense: {
        pub_id: 'partner-subito',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MARKET,
        channel_id: vertical,
        adsafe: 'high',
        hl: 'it',
        link_target: '_blank',
        ad_page: 1,
        max_term_length: 200,
      },
    },
    slots: [
      //Zero results:
      {
        //Ex: zero-result-fallback
        container_id: LiraContainerIds.listing.zeroResult,
        name: 'the zero result slot',
        configurations: {
          gam: [
            {
              sequence: 1,
              unit_id: `/11825272/${vertical}/${vertical}-web/subito-${vertical}-desktop-0results-fallback`,
              sizes: ['fluid', '300x250'],
              bidding_systems: [
                {
                  bidders: [
                    {
                      name: 'onetag',
                      params: {
                        pubId: '75b3d7d3be898e0',
                      },
                    },
                    {
                      name: 'criteo',
                      params: {
                        networkId: 280,
                      },
                    },
                    {
                      name: 'criteo',
                      params: {
                        networkId: 280,
                        zoneId: 1479794,
                      },
                    },
                    {
                      name: 'rubicon',
                      params: {
                        accountId: 23660,
                        siteId: 381482,
                        zoneId: 2114030,
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: 81997,
                        adSlot: 'Subito_300x250-hb@300x250',
                      },
                    },
                    {
                      name: 'teads',
                      params: {
                        pageId: 149522,
                        placementId: 163688,
                      },
                    },
                    {
                      name: 'appnexus',
                      params: {
                        placementId: 19698617,
                      },
                    },
                    {
                      name: 'ix',
                      params: {
                        siteId: 1131817,
                      },
                    },
                  ],
                },
              ],
            },
          ],
          adsense: [
            {
              sequence: 0,
              number_of_ads: 5,
              ...(getAdSenseConfig(
                LiraContainerIds.listing.zeroResult,
                vertical,
                false
              ) ?? {}),
            },
          ],
        },
      },
      {
        //Ex: interstitial
        container_id: LiraContainerIds.listing.interstitialLazy,
        name: 'Interstitial',
        configurations: {
          gam: [
            {
              sequence: 1,
              unit_id: `/11825272/${vertical}/${vertical}-web/subito-${vertical}-desktop-listing-outofpage`,
              sizes: ['1x1'],
            },
          ],
        },
      },
      {
        //Ex: apn_skyscraper_tag
        container_id: LiraContainerIds.listing.aside,
        name: 'The sky scraper on the right side',
        configurations: {
          gam: [
            {
              sequence: 0,
              unit_id: `/11825272/${vertical}/${vertical}-web/subito-${vertical}-desktop-listing-skyscraper`,
              sizes: ['160x600'],
              bidding_systems: [
                {
                  bidders: [
                    {
                      name: 'onetag',
                      params: {
                        pubId: '75b3d7d3be898e0',
                      },
                    },
                    {
                      name: 'criteo',
                      params: {
                        networkId: 280,
                      },
                    },
                    {
                      name: 'rubicon',
                      params: {
                        accountId: 23660,
                        siteId: 381482,
                        zoneId: 2114030,
                      },
                    },

                    {
                      name: 'openx',
                      params: {
                        delDomain: 'adevintaitaly-d.openx.net',
                        unit: 541156882,
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_160x600-hb@160x600',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_120x600-hb@120x600',
                      },
                    },
                    {
                      name: 'teads',
                      params: {
                        pageId: 149522,
                        placementId: 163688,
                      },
                    },
                    {
                      name: 'appnexus',
                      params: {
                        placementId: 19698611,
                      },
                    },
                    {
                      name: 'ix',
                      params: {
                        siteId: 1131817,
                      },
                    },
                  ],
                },
              ],
              refresh: {
                enabled: true,
                interval: 30,
              },
            },
          ],
        },
      },
      {
        //Ex: apn_top_tag
        container_id: LiraContainerIds.listing.top,
        name: 'The top ad',
        configurations: {
          gam: [
            {
              sequence: 0,
              unit_id: `/11825272/${vertical}/${vertical}-web/subito-${vertical}-desktop-listing-top`,
              sizes: ['728x90', '970x250'],
              bidding_systems: [
                {
                  bidders: [
                    {
                      name: 'onetag',
                      params: {
                        pubId: '75b3d7d3be898e0',
                      },
                    },
                    {
                      name: 'criteo',
                      params: {
                        networkId: 280,
                      },
                    },
                    {
                      name: 'rubicon',
                      params: {
                        accountId: 23660,
                        siteId: 381482,
                        zoneId: 2114030,
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_728x90-hb@728x90',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_970x250-hb@970x250',
                      },
                    },
                    {
                      name: 'teads',
                      params: {
                        pageId: 149522,
                        placementId: 163688,
                      },
                    },
                    {
                      name: 'appnexus',
                      params: {
                        placementId: 19698601,
                      },
                    },
                    {
                      name: 'ix',
                      params: {
                        siteId: 1131817,
                      },
                    },

                    {
                      name: 'openx',
                      params: {
                        delDomain: 'adevintaitaly-d.openx.net',
                        unit: 541156883,
                      },
                    },
                  ],
                },
              ],
              refresh: {
                enabled: true,
                interval: 30,
              },
            },
          ],
        },
      },
      {
        //Ex: apn_skyscraper_tag_right
        container_id: LiraContainerIds.listing.skyscraperRight,
        name: 'The skyscraper on the right',
        show_when_unfilled: LiraContainerIds.listing.skin,
        configurations: {
          gam: [
            {
              sequence: 0,
              unit_id: `/11825272/${vertical}/${vertical}-web/subito-${vertical}-desktop-listing-skyscraper-right`,
              sizes: ['300x600', '160x600', '120x600'],
              bidding_systems: [
                {
                  bidders: skyscrapernames,
                },
              ],
              refresh: {
                enabled: true,
                interval: 30,
              },
            },
          ],
        },
      },
      {
        //Ex: apn_skyscraper_tag_left
        container_id: LiraContainerIds.listing.skyscraperLeft,
        name: 'The skyscraper on the left',
        show_when_unfilled: LiraContainerIds.listing.skin,
        configurations: {
          gam: [
            {
              sequence: 0,
              unit_id: `/11825272/${vertical}/${vertical}-web/subito-${vertical}-desktop-listing-skyscraper-left`,
              sizes: ['300x600', '160x600', '120x600'],
              bidding_systems: [
                {
                  bidders: skyscrapernames,
                },
              ],
              refresh: {
                enabled: true,
                interval: 30,
              },
            },
          ],
        },
      },
      {
        //Ex: desktop-after-listing-lp
        container_id: LiraContainerIds.listing.inContentBottom,
        name: 'Below listing',
        configurations: {
          gam: [
            {
              sequence: 1,
              unit_id: `/11825272/${vertical}/${vertical}-web/subito-${vertical}-desktop-listing-fallbackbottom`,
              sizes: ['300x250'],
              bidding_systems: [
                {
                  bidders: [
                    {
                      name: 'onetag',
                      params: {
                        pubId: '75b3d7d3be898e0',
                      },
                    },
                    {
                      name: 'criteo',
                      params: {
                        networkId: 280,
                        zoneId: 1479794,
                      },
                    },
                  ],
                },
              ],
            },
          ],
          adsense: [
            {
              sequence: 0,
              number_of_ads: 5,
              ...(getAdSenseConfig(
                LiraContainerIds.listing.inContentBottom,
                vertical,
                false
              ) ?? {}),
            },
          ],
        },
      },
      {
        container_id: LiraContainerIds.listing.inContentTop,
        name: 'Above listing top',
        configurations: {
          gam: [
            {
              sequence: 1,
              unit_id: `/11825272/${vertical}/${vertical}-web/subito-${vertical}-desktop-listing-fallback`,
              sizes: ['fluid', '1x1'],
              bidding_systems: [
                {
                  bidders: [
                    {
                      name: 'onetag',
                      params: {
                        pubId: '75b3d7d3be898e0',
                      },
                    },
                    {
                      name: 'criteo',
                      params: {
                        networkId: 280,
                      },
                    },
                    {
                      name: 'openx',
                      params: {
                        delDomain: 'adevintaitaly-d.openx.net',
                        unit: 541156884,
                      },
                    },
                    {
                      name: 'criteo',
                      params: {
                        networkId: 280,
                        zoneId: 1479794,
                      },
                    },
                    {
                      name: 'rubicon',
                      params: {
                        accountId: 23660,
                        siteId: 381482,
                        zoneId: 2114030,
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_320x50-hb@320x50',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_320x100-hb@320x100',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_300x50-hb@300x50',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_300x100-hb@300x100',
                      },
                    },
                    {
                      name: 'teads',
                      params: {
                        pageId: 149522,
                        placementId: 163688,
                      },
                    },
                    {
                      name: 'appnexus',
                      params: {
                        placementId: 19698628,
                      },
                    },
                    {
                      name: 'ix',
                      params: {
                        siteId: 1131819,
                      },
                    },
                  ],
                },
              ],
            },
          ],
          adsense: [
            {
              sequence: 0,
              number_of_ads: 1,
              ...(getAdSenseConfig(
                LiraContainerIds.listing.inContentTop,
                vertical,
                false
              ) ?? {}),
            },
          ],
        },
      },
    ],
  };

  //Different skin bidders for Motors
  if (vertical === 'motors') {
    desktopFallbackConfig.slots.push({
      //Ex: apn_skin_tag
      container_id: LiraContainerIds.listing.skin,
      name: 'The skin',
      configurations: {
        gam: [
          {
            sequence: 0,
            unit_id: `/11825272/${vertical}/${vertical}-web/subito-${vertical}-desktop-listing-skin`,
            sizes: [
              '1x1',
              '2x2',
              '728x90',
              '1920x880',
              '1800x1000',
              '1920x1080',
            ],
            bidding_systems: [
              {
                bidders: [
                  {
                    name: 'appnexus',
                    params: {
                      placementId: 19832846,
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    });
  } else {
    desktopFallbackConfig.slots.push({
      //Ex: apn_skin_tag
      container_id: LiraContainerIds.listing.skin,
      name: 'The skin',
      configurations: {
        gam: [
          {
            sequence: 0,
            unit_id: `/11825272/${vertical}/${vertical}-web/subito-${vertical}-desktop-listing-skin`,
            sizes: [
              '1x1',
              '2x2',
              '728x90',
              '1920x880',
              '1800x1000',
              '1920x1080',
            ],
            bidding_systems: [
              {
                bidders: [
                  {
                    name: 'criteo',
                    params: {
                      networkId: 280,
                    },
                  },
                  {
                    name: 'rubicon',
                    params: {
                      accountId: 23660,
                      siteId: 381482,
                      zoneId: 2114030,
                    },
                  },
                  {
                    name: 'pubmatic',
                    params: {
                      publisherId: '81997',
                      adSlot: 'Subito_728x90-hb@728x90',
                    },
                  },
                  {
                    name: 'teads',
                    params: {
                      pageId: 149522,
                      placementId: 163688,
                    },
                  },
                  {
                    name: 'appnexus',
                    params: {
                      placementId: 19698601,
                    },
                  },
                  {
                    name: 'appnexus',
                    params: {
                      placementId: 19832817,
                    },
                  },
                  {
                    name: 'ix',
                    params: {
                      siteId: 1131817,
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    });
  }

  return desktopFallbackConfig;
};

export const getMsiteFallbackConfig = (vertical: Vertical): HebeModel => {
  return {
    name: 'listing',
    page_level_settings: {
      adsense: {
        pub_id: 'partner-subito',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_MARKET,
        channel_id: vertical,
        adsafe: 'high',
        hl: 'it',
        link_target: '_blank',
        ad_page: 1,
        max_term_length: 200,
      },
    },
    slots: [
      //Zero results:
      {
        //Ex: zero-result-fallback
        container_id: LiraContainerIds.listing.zeroResult,
        name: 'the zero result slot',
        configurations: {
          gam: [
            {
              sequence: 1,
              unit_id: `/11825272/${vertical}/${vertical}-web/subito-${vertical}-msite-0results-fallback`,
              sizes: ['fluid', '1x1', '300x250', '300x600', '320x50'],
              bidding_systems: [
                {
                  bidders: [
                    {
                      name: 'onetag',
                      params: {
                        pubId: '75b3d7d3be898e0',
                      },
                    },
                    {
                      name: 'criteo',
                      params: {
                        networkId: 280,
                      },
                    },
                    {
                      name: 'criteo',
                      params: {
                        networkId: 280,
                        zoneId: 1479794,
                      },
                    },
                    {
                      name: 'openx',
                      params: {
                        delDomain: 'adevintaitaly-d.openx.net',
                        unit: 541156884,
                      },
                    },
                    {
                      name: 'rubicon',
                      params: {
                        accountId: 23660,
                        siteId: 381482,
                        zoneId: 2114030,
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_300x250-hb@300x250',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_320x50-hb@320x50',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_320x100-hb@320x100',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_300x50-hb@300x50',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_300x100-hb@300x100',
                      },
                    },
                    {
                      name: 'teads',
                      params: {
                        pageId: 149522,
                        placementId: 163688,
                      },
                    },
                    {
                      name: 'appnexus',
                      params: {
                        placementId: 19698628,
                      },
                    },
                    {
                      name: 'ix',
                      params: {
                        siteId: 1131819,
                      },
                    },
                  ],
                },
              ],
            },
          ],
          adsense: [
            {
              sequence: 0,
              number_of_ads: 5,
              ...(getAdSenseConfig(
                LiraContainerIds.listing.zeroResult,
                vertical,
                true
              ) ?? {}),
            },
          ],
        },
      },
      {
        //Ex: interstitial
        container_id: LiraContainerIds.listing.interstitial,
        name: 'Interstitial',
        configurations: {
          gam: [
            {
              sequence: 1,
              unit_id: `/11825272/${vertical}/${vertical}-web/subito-${vertical}-msite-listing-interstitial`,
              sizes: ['1x1', '300x250', '320x480'],
            },
          ],
        },
      },
      {
        //Ex: msite-after-listing-lp
        container_id: LiraContainerIds.listing.inContentBottom,
        name: 'Below listing bottom',
        configurations: {
          gam: [
            {
              unit_id:
                '/11825272/subito/subito-web/subito-subito-desktop-listing-fallbackbottom',
              sequence: 1,
              refresh: {
                enabled: false,
                interval: 0,
              },
              sizes: ['300x250'],
              bidding_systems: [
                {
                  name: '',
                  bidders: [
                    {
                      name: 'onetag',
                      params: {
                        pub_id: '75b3d7d3be898e0',
                      },
                    },
                    {
                      name: 'triplelift',
                      params: {
                        inventoryCode: 'Adevinta_Subito_300x250_s2s',
                      },
                    },
                    {
                      name: 'criteo',
                      params: {
                        networkId: 280,
                        zoneId: 1479794,
                      },
                    },
                  ],
                },
              ],
            },
          ],
          adsense: [
            {
              sequence: 0,
              number_of_ads: 5,
              ...(getAdSenseConfig(
                LiraContainerIds.listing.inContentBottom,
                vertical,
                true
              ) ?? {}),
            },
          ],
        },
      },
      {
        //Ex: msite-before-listing-lp
        container_id: LiraContainerIds.listing.inContentTop,
        name: 'Above listing',
        configurations: {
          gam: [
            {
              sequence: 1,
              unit_id: `/11825272/${vertical}/${vertical}-web/subito-${vertical}-msite-listing-fallback`,
              sizes: ['fluid', '1x1'],
              bidding_systems: [
                {
                  name: '',
                  bidders: [
                    {
                      name: 'onetag',
                      params: {
                        pub_id: '75b3d7d3be898e0',
                      },
                    },
                    {
                      name: 'criteo',
                      params: {
                        networkId: 280,
                      },
                    },
                    {
                      name: 'openx',
                      params: {
                        delDomain: 'adevintaitaly-d.openx.net',
                        unit: 541156884,
                      },
                    },
                    {
                      name: 'triplelift',
                      params: {
                        inventoryCode: 'Adevinta_Subito_300x250_s2s',
                      },
                    },
                    {
                      name: 'triplelift',
                      params: {
                        inventoryCode: 'Adevinta_Subito_HDX_s2s',
                      },
                    },
                    {
                      name: 'criteo',
                      params: {
                        networkId: 280,
                        zoneId: 1479794,
                      },
                    },
                    {
                      name: 'rubicon',
                      params: {
                        accountId: 23660,
                        siteId: 381482,
                        zoneId: 2114030,
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        adSlot: 'Subito_320x50-hb@320x50',
                        publisherId: '81997',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        adSlot: 'Subito_320x100-hb@320x100',
                        publisherId: '81997',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        adSlot: 'Subito_300x50-hb@300x50',
                        publisherId: '81997',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        adSlot: 'Subito_300x100-hb@300x100',
                        publisherId: '81997',
                      },
                    },
                    {
                      name: 'teads',
                      params: {
                        pageId: 149522,
                        placementId: 163688,
                      },
                    },
                    {
                      name: 'appnexus',
                      params: {
                        placementId: 19698628,
                      },
                    },
                    {
                      name: 'ix',
                      params: {
                        siteId: 1131819,
                      },
                    },
                  ],
                },
              ],
            },
          ],
          adsense: [
            {
              sequence: 0,
              number_of_ads: 1,
              ...(getAdSenseConfig(
                LiraContainerIds.listing.inContentTop,
                vertical,
                true
              ) ?? {}),
            },
          ],
        },
      },
      {
        //Ex: reclame-listing-top
        container_id: LiraContainerIds.listing.box1,
        name: 'The first box into the listing',
        configurations: {
          gam: [
            {
              sequence: 0,
              unit_id: `/11825272/${vertical}/${vertical}-web/subito-${vertical}-msite-listing-box1`,
              sizes: [
                'fluid',
                '1x1',
                '350x55',
                '300x50',
                '320x50',
                '320x100',
                '300x250',
              ],
              bidding_systems: [
                {
                  bidders: [
                    {
                      name: 'onetag',
                      params: {
                        pubId: '75b3d7d3be898e0',
                      },
                    },
                    {
                      name: 'criteo',
                      params: {
                        networkId: 280,
                      },
                    },
                    {
                      name: 'criteo',
                      params: {
                        networkId: 280,
                        zoneId: 1479794,
                      },
                    },
                    {
                      name: 'rubicon',
                      params: {
                        accountId: 23660,
                        siteId: 381482,
                        zoneId: 2114030,
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_320x100-hb@320x100',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_300x250-hb@300x250',
                      },
                    },

                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_320x50-hb@320x50',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_300x50-hb@300x50',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_300x100-hb@300x100',
                      },
                    },
                    {
                      name: 'teads',
                      params: {
                        pageId: 149522,
                        placementId: 163688,
                      },
                    },
                    {
                      name: 'appnexus',
                      params: {
                        placementId: 19698628,
                      },
                    },
                    {
                      name: 'ix',
                      params: {
                        siteId: 1131819,
                      },
                    },
                    {
                      name: 'openx',
                      params: {
                        delDomain: 'adevintaitaly-d.openx.net',
                        unit: 541156884,
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      },
      {
        //Ex: li-gpt-msite-listing-2
        container_id: LiraContainerIds.listing.box2,
        name: 'The second box into the listing',
        configurations: {
          gam: [
            {
              sequence: 0,
              unit_id: `/11825272/${vertical}/${vertical}-web/subito-${vertical}-msite-listing-box2`,
              sizes: [
                'fluid',
                '1x1',
                '350x55',
                '300x50',
                '320x50',
                '320x100',
                '300x600',
                '300x250',
              ],
              bidding_systems: [
                {
                  bidders: [
                    {
                      name: 'onetag',
                      params: {
                        pubId: '75b3d7d3be898e0',
                      },
                    },
                    {
                      name: 'criteo',
                      params: {
                        networkId: 280,
                      },
                    },
                    {
                      name: 'criteo',
                      params: {
                        networkId: 280,
                        zoneId: 1479794,
                      },
                    },
                    {
                      name: 'rubicon',
                      params: {
                        accountId: 23660,
                        siteId: 381482,
                        zoneId: 2114030,
                      },
                    },
                    {
                      name: 'openx',
                      params: {
                        delDomain: 'adevintaitaly-d.openx.net',
                        unit: 541156881,
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_320x100-hb@320x100',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_300x250-hb@300x250',
                      },
                    },

                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_320x50-hb@320x50',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_300x600-hb@300x600',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_300x50-hb@300x50',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_300x100-hb@300x100',
                      },
                    },
                    {
                      name: 'teads',
                      params: {
                        pageId: 149522,
                        placementId: 163688,
                      },
                    },
                    {
                      name: 'openx',
                      params: {
                        delDomain: 'adevintaitaly-d.openx.net',
                        unit: 541156884,
                      },
                    },
                    {
                      name: 'appnexus',
                      params: {
                        placementId: 19698628,
                      },
                    },
                    {
                      name: 'ix',
                      params: {
                        siteId: 1131819,
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      },
      {
        //Ex: reclame-listing-bottom
        container_id: LiraContainerIds.listing.box3,
        name: 'The second third into the listing',
        configurations: {
          gam: [
            {
              sequence: 0,
              unit_id: `/11825272/${vertical}/${vertical}-web/subito-${vertical}-msite-listing-box3`,
              sizes: [
                'fluid',
                '1x1',
                '350x55',
                '300x50',
                '320x50',
                '320x100',
                '300x250',
              ],
              bidding_systems: [
                {
                  bidders: [
                    {
                      name: 'onetag',
                      params: {
                        pubId: '75b3d7d3be898e0',
                      },
                    },
                    {
                      name: 'criteo',
                      params: {
                        networkId: 280,
                      },
                    },
                    {
                      name: 'criteo',
                      params: {
                        networkId: 280,
                        zoneId: 1479794,
                      },
                    },
                    {
                      name: 'rubicon',
                      params: {
                        accountId: 23660,
                        siteId: 381482,
                        zoneId: 2114030,
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_320x100-hb@320x100',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_300x250-hb@300x250',
                      },
                    },

                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_320x50-hb@320x50',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_300x50-hb@300x50',
                      },
                    },
                    {
                      name: 'pubmatic',
                      params: {
                        publisherId: '81997',
                        adSlot: 'Subito_300x100-hb@300x100',
                      },
                    },
                    {
                      name: 'teads',
                      params: {
                        pageId: 149522,
                        placementId: 163688,
                      },
                    },
                    {
                      name: 'appnexus',
                      params: {
                        placementId: 19698628,
                      },
                    },
                    {
                      name: 'ix',
                      params: {
                        siteId: 1131819,
                      },
                    },
                    {
                      name: 'openx',
                      params: {
                        delDomain: 'adevintaitaly-d.openx.net',
                        unit: 541156884,
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      },
    ],
  };
};
